import type { ai as enAi } from "../en/ai";

export const ai: typeof enAi = {
  page: {
    heading: "Assistente IA",
    intro:
      "Questo è il centro operativo della tua IA. L'IA di Quote Desk calcola il prezzo delle righe di preventivo, prepara controfferte e legge gli ordini d'acquisto — sempre come bozza che tu approvi, mai in autonomia. Insegnale la tua politica e il tuo tono di voce una volta sola qui sotto, e ogni suggerimento la seguirà.",
  },
  banners: {
    briefSaved:
      "Brief IA salvato — ogni nuovo suggerimento, controfferta e bozza rivolta all'acquirente ora lo segue.",
    budgetSaved: "Budget IA mensile impostato a ${{amount}}.",
  },
  budget: {
    heading: "Utilizzo IA di questo mese",
    usedOf: "utilizzati su",
    remainingBadge: "{{amount}} rimanenti",
    budgetReachedBadge: "Budget raggiunto — IA in pausa fino al 1° del mese",
    description:
      "Copre i suggerimenti di prezzo IA, le controfferte e l'analisi degli ordini d'acquisto. Quando il limite viene raggiunto, le funzioni IA si mettono in pausa con un messaggio chiaro (niente si blocca) e riprendono automaticamente il 1° del mese.",
    monthlyBudgetLabel: "Budget mensile (USD)",
    monthlyBudgetHelpText: "Tra ${{min}} e ${{max}}. Mese intenso tipico: $10–15.",
    saveButton: "Salva budget",
  },
  brief: {
    heading: "Brief IA — istruisci la tua IA una volta sola",
    description:
      "Il Brief accompagna ogni richiesta all'IA, così i suggerimenti suonano come te e restano dentro le tue regole di prezzo. Finché non li modifichi si applicano valori predefiniti sensati.",
    businessContextLabel: "Contesto aziendale",
    businessContextPlaceholder:
      "es. Vendiamo all'ingrosso attrezzature per caffetteria specialty a bar e torrefazioni in Nord America.",
    businessContextHelpText: "Cosa vendi e chi lo acquista — aiuta l'IA a ragionare come qualcuno del tuo team.",
    maxDiscountLabel: "Sconto massimo (%)",
    maxDiscountHelpText: "Tetto massimo rispetto al prezzo di listino. Applicato nel codice, non solo comunicato all'IA.",
    floorMarginLabel: "Margine minimo (%) — opzionale",
    floorMarginHelpText:
      "Non scendere mai sotto questo margine lordo quando il costo unitario è noto. Lascia vuoto per saltare.",
    preferredTermsLabel: "Termini di pagamento preferiti",
    preferredTermsPlaceholder: "es. Netto 30",
    neverOfferLabel: "Da non offrire mai",
    neverOfferPlaceholder:
      "es. Spedizione gratuita per ordini sotto i $2.000. Sconti sulla linea Pro-X.",
    neverOfferHelpText: "Regole rigide che l'IA non deve mai proporre, in linguaggio semplice.",
    toneLabel: "Tono",
    negotiationStanceLabel: "Approccio negoziale",
    buyerKnowledgeLabel: "Livello di competenza dell'acquirente",
    buyerKnowledgeAutoOption: "auto (in base all'acquirente)",
    voiceSampleLabel: "Esempio di tono di voce del brand — opzionale",
    voiceSampleHelpText:
      "Incolla un paragrafo che suoni come te — l'IA lo replica nel linguaggio rivolto all'acquirente.",
    signatureNameLabel: "Firma i messaggi rivolti all'acquirente come",
    signatureNamePlaceholder: "es. Dana di Summit Supply",
    currencyLabel: "Valuta",
    currencyHelpText: "Codice di 3 lettere che l'IA usa quando parla di prezzi — di solito la valuta del tuo negozio.",
    saveButton: "Salva Brief IA",
  },
  activity: {
    heading: "Attività IA recente",
    empty:
      "Ancora nulla — l'attività IA compare qui mentre lavori. Apri un preventivo in bozza e prova “Suggerisci prezzi con l'IA”, oppure carica un ordine d'acquisto per vedere l'analizzatore in azione. Ogni esecuzione mostra il suo costo e quanto storico ordini l'ha supportata.",
    kindPriceSuggestion: "Suggerimento di prezzo",
    kindCounterOffer: "Controfferta",
    dataPrefix: "dati:",
    status: {
      DRAFT: "Bozza",
      APPLIED: "Applicato",
      DISMISSED: "Ignorato",
      REFUSED: "Rifiutato",
    },
  },
  errors: {
    saveBriefFailed: "Impossibile salvare il Brief IA. Riprova.",
  },
  briefForm: {
    labelFloorMargin: "Il margine minimo",
    labelMaxDiscount: "Lo sconto massimo",
    labelBusinessContext: "Il contesto aziendale",
    labelPreferredTerms: "I termini di pagamento preferiti",
    labelNeverOffer: 'Il campo "Non offrire mai"',
    labelSignatureName: "Il nome della firma",
    labelVoiceSample: "L'esempio di tono di voce",
    mustBeNumber: "{{label}} deve essere un numero (es. 15 per 15%).",
    mustBeBetween: "{{label}} deve essere compreso tra {{min}}% e {{max}}%.",
    maxDiscountRequired: "Lo sconto massimo è obbligatorio (inserisci 0 per vietare gli sconti).",
    pickTone: "Scegli un tono.",
    pickBuyerKnowledge: "Scegli un livello di competenza dell'acquirente.",
    pickStance: "Scegli un approccio alla negoziazione.",
    currencyInvalid: "La valuta deve essere un codice di 3 lettere (es. EUR).",
    textTooLong: "{{label}} è troppo lungo (massimo {{max}} caratteri).",
    budgetPositive: "Il budget IA mensile deve essere un importo positivo in dollari.",
  },
};
